import { Plan } from "../../interfaces/Plan";

const PlanCard = ({ title, price, details }: Plan) => {
  return (
    <div className="plan-card d-flex flex-column justify-content-between">
      <div>
        <p className="plan-title">{title}</p>
        <p className="plan-price">৳ {price}</p>
        <div className="details">
          {Object.entries(details)?.map(([, feature]) => (
            <div key={feature}>{feature}</div>
          ))}
        </div>
      </div>
      <div>
        <a
          href={`https://api.whatsapp.com/send?phone=8801805082528&text=wp-${title}`}
          className="learn-more"
        >
          Message on WhatsApp
        </a>
      </div>
    </div>
  );
};

export default PlanCard;
